var _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExportPdf(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8332 16.625H3.1665C2.55808 16.6443 1.96677 16.422 1.52176 16.0066C1.07675 15.5913 0.814209 15.0167 0.791504 14.4084V8.70835C0.791504 8.4984 0.874914 8.297 1.02338 8.14857C1.17184 8.00013 1.3732 7.91669 1.58317 7.91669H17.4165C17.6265 7.91669 17.8279 8.00013 17.9763 8.14857C18.1247 8.297 18.2082 8.4984 18.2082 8.70835V14.4084C18.1855 15.0167 17.9229 15.5913 17.4779 16.0066C17.0329 16.422 16.4416 16.6443 15.8332 16.625Z",
    fill: "url(#paint0_linear_203_320)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4165 7.91669C17.2066 7.91669 17.0052 8.00013 16.8567 8.14857C16.7083 8.297 16.6248 8.4984 16.6248 8.70835V14.4084C16.5991 14.5953 16.5027 14.7652 16.3554 14.883C16.2081 15.0008 16.0211 15.0577 15.8332 15.0417H3.1665C2.97853 15.0577 2.7916 15.0008 2.6443 14.883C2.49698 14.7652 2.40053 14.5953 2.37484 14.4084V8.70835C2.37484 8.4984 2.29143 8.297 2.14297 8.14857C1.9945 8.00013 1.79314 7.91669 1.58317 7.91669C1.3732 7.91669 1.17184 8.00013 1.02338 8.14857C0.874914 8.297 0.791504 8.4984 0.791504 8.70835V14.4084C0.814209 15.0167 1.07675 15.5913 1.52176 16.0066C1.96677 16.422 2.55808 16.6443 3.1665 16.625H15.8332C16.4416 16.6443 17.0329 16.422 17.4779 16.0066C17.9229 15.5913 18.1855 15.0167 18.2082 14.4084V8.70835C18.2082 8.4984 18.1247 8.297 17.9763 8.14857C17.8279 8.00013 17.6265 7.91669 17.4165 7.91669Z",
    fill: "url(#paint1_linear_203_320)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4028 8.84275L10.2865 9.96692V3.1665C10.2865 2.95655 10.2031 2.75515 10.0547 2.60671C9.90622 2.45828 9.70482 2.37483 9.49487 2.37483C9.28492 2.37483 9.08352 2.45828 8.93508 2.60671C8.78656 2.75515 8.7032 2.95655 8.7032 3.1665V9.96692L7.58695 8.84275C7.51333 8.76855 7.42577 8.70966 7.32934 8.66946C7.23284 8.62927 7.12937 8.60858 7.02487 8.60858C6.92037 8.60858 6.8169 8.62927 6.72039 8.66946C6.62397 8.70966 6.53641 8.76855 6.46278 8.84275C6.3894 8.91673 6.33137 9.00446 6.29194 9.10091C6.2526 9.19736 6.23257 9.30064 6.2332 9.40484C6.23257 9.50903 6.2526 9.61231 6.29194 9.70876C6.33137 9.80521 6.3894 9.89295 6.46278 9.96692L8.93278 12.4369C9.06832 12.5722 9.24834 12.6538 9.43945 12.6665H9.58987C9.74828 12.6477 9.89727 12.5815 10.0174 12.4765H10.057L12.5269 9.96692C12.676 9.81785 12.7598 9.61566 12.7598 9.40484C12.7598 9.19402 12.676 8.99182 12.5269 8.84275C12.3779 8.69368 12.1757 8.60993 11.9649 8.60993C11.754 8.60993 11.5519 8.69368 11.4028 8.84275Z",
    fill: "url(#paint2_linear_203_320)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_203_320",
    x1: 9.49984,
    y1: 7.91669,
    x2: 9.49984,
    y2: 16.6266,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAF6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ADDCFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_203_320",
    x1: 9.49984,
    y1: 7.91669,
    x2: 9.49984,
    y2: 16.6266,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4071FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_203_320",
    x1: 9.49645,
    y1: 12.6665,
    x2: 9.49645,
    y2: 2.37483,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4071FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExportPdf);
export default __webpack_public_path__ + "static/media/exportPdf.cdca606b4eea2197b8a4a96c34b8204a.svg";
export { ForwardRef as ReactComponent };